/* Card purchase panel (reference style): opens inside the card, keeps the subscription consent rule. */
(() => {
  if (window.bwCardPanel) return;
  window.bwCardPanel = true;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const parts = (panel) => {
    const form = panel.querySelector('[data-bw-card-form]');
    return {
      form,
      plan: form && form.querySelector('[data-bw-card-plan]'),
      consent: form && form.querySelector('[data-bw-card-consent]'),
      wrap: form && form.querySelector('[data-bw-card-consent-wrap]'),
      error: form && form.querySelector('[data-bw-card-consent-error]'),
      choice: () => form && form.querySelector('[data-bw-card-choice]:checked'),
    };
  };

  const sync = (panel, reset) => {
    const p = parts(panel);
    if (!p.form) return;
    if (reset && p.consent) { p.consent.checked = false; if (p.error) p.error.hidden = true; }
    const value = p.choice() ? p.choice().value : '';
    const sub = value !== '';
    if (p.wrap) p.wrap.hidden = !sub;
    if (p.consent) p.consent.required = sub;
    if (p.plan) { p.plan.value = value; p.plan.disabled = !sub || !(p.consent && p.consent.checked); }
    panel.querySelectorAll('.bw-card-option').forEach((option) => {
      const input = option.querySelector('[data-bw-card-choice]');
      option.classList.toggle('is-selected', !!(input && input.checked));
    });
  };

  const hostOf = (el) => el.closest('[data-bw-card-host]') || el.parentElement;

  /* Desktop: a short host (a wide Shop by Goal card, a landing card) grows while open so the whole panel shows
     without an inner scroll. Phone uses the bottom sheet, so nothing changes there. */
  const fit = (panel, host) => {
    host.style.minHeight = '';
    if (window.matchMedia('(max-width: 749px)').matches) return;
    const need = panel.scrollHeight + (panel.offsetHeight - panel.clientHeight) + 16;
    if (need > host.getBoundingClientRect().height) host.style.minHeight = need + 'px';
  };

  const open = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const host = hostOf(panel);
    const keepY = window.scrollY;
    const hold = () => { if (Math.abs(window.scrollY - keepY) > 2) window.scrollTo({ top: keepY, behavior: 'instant' }); };
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    host.classList.add('is-card-panel-open');
    sync(panel, true);
    fit(panel, host);
    if (reduce()) panel.dataset.open = 'true';
    else requestAnimationFrame(() => { panel.dataset.open = 'true'; });
    const close = panel.querySelector('[data-bw-card-close]');
    if (close) close.focus({ preventScroll: true });
    hold();
    requestAnimationFrame(hold);
    setTimeout(hold, 250);
  };

  const shut = (panel, restoreFocus) => {
    if (!panel || panel.hidden) return;
    const button = document.querySelector('[data-bw-card-open][aria-controls="' + panel.id + '"]');
    delete panel.dataset.open;
    panel.hidden = true;
    hostOf(panel).classList.remove('is-card-panel-open');
    hostOf(panel).style.minHeight = '';
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      if (restoreFocus) button.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bw-card-open]');
    if (opener) {
      event.preventDefault();
      document.querySelectorAll('[data-bw-card-panel]:not([hidden])').forEach((other) => { if (other.id !== opener.getAttribute('aria-controls')) shut(other, false); });
      open(opener);
      return;
    }
    const closer = event.target.closest('[data-bw-card-close]');
    if (closer) { shut(closer.closest('[data-bw-card-panel]'), true); return; }
    /* A tap on the dimmed area (the host's scrim) closes the open panel. */
    if (event.target.matches && event.target.matches('[data-bw-card-host].is-card-panel-open')) {
      shut(event.target.querySelector('[data-bw-card-panel]:not([hidden])'), true);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest && event.target.closest('[data-bw-card-panel]');
    if (panel) { event.stopPropagation(); shut(panel, true); }
  });

  document.addEventListener('change', (event) => {
    const panel = event.target.closest && event.target.closest('[data-bw-card-panel]');
    if (!panel) return;
    if (event.target.matches('[data-bw-card-choice]')) {
      const p = parts(panel);
      if (p.consent) p.consent.checked = false;
      if (p.error) p.error.hidden = true;
    }
    if (event.target.matches('[data-bw-card-consent]')) {
      const p = parts(panel);
      if (p.error) p.error.hidden = true;
    }
    sync(panel, false);
  });

  /* Window capture phase: runs before the theme's document level on:submit delegation (component.js). */
  window.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('[data-bw-card-form]');
    if (!form) return;
    const panel = form.closest('[data-bw-card-panel]');
    const p = parts(panel);
    const value = p.choice() ? p.choice().value : '';
    if (value && !(p.consent && p.consent.checked)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (p.error) p.error.hidden = false;
      if (p.consent) p.consent.focus({ preventScroll: false });
      return;
    }
    if (p.plan) { p.plan.value = value; p.plan.disabled = !value; }
  }, true);
})();
